import { Card, Tag, Typography, Empty } from "antd";
import React, { useEffect, useState } from "react";
import { professionalService } from "../_services";

const { Title, Text } = Typography;

export const MapCities = () => {
  const [mappedCities, setMappedCities] = useState([]);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));    

    professionalService.getCity().then((res) => {
      const allCities = res.pc_cities || [];

      if (user && Array.isArray(user.map_cities)) {
        const filteredCities = allCities.filter((city) =>
          user.map_cities.includes(city.id)
        );

        setMappedCities(filteredCities);
      }
    });
  }, []);

  console.log("mappedCities", mappedCities);
  return (
    <Card title="Mapped Cities" bordered={false} style={{ borderRadius: 8 }}>
      {mappedCities.length > 0 ? (
        <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
          {mappedCities.map((city) => (
            <Tag
              key={city.id}
              color="blue"
              style={{
                padding: "6px 14px",
                fontSize: 14,
                borderRadius: 20,
              }}
            >
              {city.City}
            </Tag>
          ))}
        </div>
      ) : (
        <Empty description="No cities mapped" />
      )}
    </Card>
  );
};
